export default __webpack_public_path__ + "static/media/ei_step.a27fab17.png";